import B2BPartnerships from "@/components/B2BPartnerships";
import usePageTitle from "@/lib/usePageTitle";

export default function B2BPage() {
  usePageTitle("B2B Partnerships");
  return <B2BPartnerships />;
}
